import { Card, Typography, Divider } from "antd";

const { Title, Text } = Typography;

const ResearchCard = ({ item, xURL, xLng }) => {
  return (
    <Card hoverable className="research-card">
      <div className="research-img-wrap">
        <img
          src={`${xURL}file_research/${item.picname}`}
          alt="profile"
        />
      </div>

      <Title level={5}>{item.name}</Title>
      <Text>{item.position}</Text><br />
      <Text type="secondary">{item.position_aca}</Text><br />
      <Text type="secondary">{item.email}</Text>

      {item.positionex?.[0] !== "-" && (
        <>
          <Divider />
          <Text strong>Management Position</Text>
          {item.positionex.map((p, i) => (
            <div key={i}>• {p}</div>
          ))}
        </>
      )}

      <Divider />

      <Text strong>Expertise</Text>
      <ul>
        {item.researcher_expertise?.map(
          (r, i) => i > 0 && <li key={i}>{r}</li>
        )}
      </ul>

      <div
        className="more-link"
        onClick={() =>
          window.open(
            `/Research_rihes_detail_en?pages=${xLng}&rid=${item.id}`,
            "_blank"
          )
        }
      >
         More information →
      </div>
    </Card>
  );
};

export default ResearchCard;
